import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  decrement,
  increment,
  removeFromCart,
} from "../../redux/shopping/actions";

const CartItem = ({ item }) => {
  const dispatch = useDispatch();
  const { name, category, price, quantity, image } = item;
  const { products } = useSelector((state) => state.shopping);

  const checkIncrement = (item) => {
    const product = products.find((product) => product.id === item.id);
    if (product.quantity <= 0) {
      return true;
    }
    return false;
  };

  return (
    <div className="cartCard">
      <div className="flex items-center col-span-6 space-x-6">
        {/* cart image */}
        <img
          className="lws-cartImage"
          src={image}
          alt="product"
        />
        {/* cart item info */}
        <div className="space-y-2">
          <h4 className="lws-cartName">{name}</h4>
          <p className="lws-cartCategory">{category}</p>
          <p>
            BDT <span className="lws-cartPrice">{price}</span>
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
        {/* amount buttons */}
        <div className="flex items-center space-x-4">
          <button
            disabled={checkIncrement(item)}
            className="lws-incrementQuantity"
            onClick={() => dispatch(increment(item))}
          >
            <i className="text-lg fa-solid fa-plus" />
          </button>
          <span className="lws-cartQuantity">{quantity}</span>
          <button
            disabled={quantity <= 1}
            className="lws-decrementQuantity"
            onClick={() => dispatch(decrement(item))}
          >
            <i className="text-lg fa-solid fa-minus" />
          </button>
        </div>
        {/* price */}
        <p className="text-lg font-bold">
          BDT <span className="lws-calculatedPrice">{quantity * price}</span>
        </p>
      </div>
      {/* delete button */}
      <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
        <button
          className="lws-removeFromCart"
          onClick={() => dispatch(removeFromCart(item))}
        >
          <i className="text-lg text-red-400 fa-solid fa-trash" />
        </button>
      </div>
    </div>
  );
};

export default CartItem;
